import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { motion } from 'framer-motion';
import './Careers.css';
import { FaLaptopCode, FaRegClock, FaUsers, FaArrowRight } from 'react-icons/fa';
import AnimatedOnScroll from '../components/AnimatedOnScroll'; // <-- NEW IMPORT

// Helper function to format the date
const formatDate = (dateString) => {
  const options = { year: 'numeric', month: 'long', day: 'numeric' };
  return new Date(dateString).toLocaleDateString(undefined, options);
};

// On-load animation for the header
const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
};

const Careers = () => {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Fetch jobs from your Django API
    axios.get('/api/jobs/')
      .then(res => {
        setJobs(res.data);
        setLoading(false);
      })
      .catch(err => {
        console.error("Error fetching jobs:", err);
        setLoading(false);
      });
  }, []);

  return (
    <motion.div
      initial="hidden"
      animate="visible"
      exit={{ opacity: 0 }}
      style={{ paddingTop: '100px' }}
    >
      {/* 1. Hero Section (Uses on-load animation) */}
      <section className="container careers-hero">
        <motion.h1 variants={itemVariants}>Join Our Team</motion.h1>
        <motion.p variants={itemVariants} style={{ transitionDelay: '0.1s' }}>
          We're looking for passionate, innovative, and driven individuals to
          help us build the future of software. Your work will make an impact.
        </motion.p>
      </section>

      {/* 2. Perks & Benefits Section (Refactored) */}
      <section className="container perks-section">
        <AnimatedOnScroll>
          <h2 className="section-title">Perks & Benefits</h2>
        </AnimatedOnScroll>
        <AnimatedOnScroll delay={0.1}>
          <p className="section-subtitle">We believe in taking care of our team.</p>
        </AnimatedOnScroll>

        <div className="perks-grid">
          <AnimatedOnScroll className="perk-card">
            <FaLaptopCode className="perk-icon" />
            <h3>Remote-First Culture</h3>
            <p>Work from where you're most productive. We offer flexible remote work options.</p>
          </AnimatedOnScroll>
          <AnimatedOnScroll className="perk-card" delay={0.1}>
            <FaRegClock className="perk-icon" />
            <h3>Flexible Hours</h3>
            <p>We trust you to manage your time. We focus on results, not hours clocked.</p>
          </AnimatedOnScroll>
          <AnimatedOnScroll className="perk-card" delay={0.2}>
            <FaUsers className="perk-icon" />
            <h3>Growth & Learning</h3>
            <p>Access to online courses, conference stipends, and mentorship opportunities.</p>
          </AnimatedOnScroll>
        </div>
      </section>

      {/* 3. Open Positions Section (Refactored) */}
      <section className="container open-positions-section">
        <AnimatedOnScroll>
          <h2 className="section-title">Open Positions</h2>
        </AnimatedOnScroll>

        <div className="job-list">
          {loading ? (
            <p>Loading open positions...</p>
          ) : (
            <>
              {jobs.length === 0 ? (
                <AnimatedOnScroll className="no-jobs-message">
                  No open positions at this time. Please check back soon!
                </AnimatedOnScroll>
              ) : (
                <div>
                  {jobs.map((job, index) => (
                    <AnimatedOnScroll
                      className="job-card"
                      key={job.id}
                      delay={index * 0.1}
                      data-hover
                    >
                      <div className="job-card-header">
                        <h3>{job.title}</h3>
                        <span className="job-location">{job.location}</span>
                      </div>
                      <p className="job-description">
                        {job.description.substring(0, 200)}...
                      </p>
                      <div className="job-card-footer">
                        <span className="job-posted-date">
                          Posted: {formatDate(job.posted_at)}
                        </span>
                        <a href="#" className="job-apply-link" data-hover>
                          Apply Now <FaArrowRight />
                        </a>
                      </div>
                    </AnimatedOnScroll>
                  ))}
                </div>
              )}
            </>
          )}
        </div>
      </section>

      {/* 4. Hiring Process Section (Refactored) */}
      <section className="container hiring-process-section">
         <AnimatedOnScroll>
            <h2 className="section-title">Our Hiring Process</h2>
         </AnimatedOnScroll>
        <AnimatedOnScroll delay={0.1}>
          <p className="section-subtitle">
            We keep things transparent and straightforward.
          </p>
        </AnimatedOnScroll>

        <div className="process-timeline-careers">
          <AnimatedOnScroll className="process-step-career">
            <div className="process-step-number-career">1</div>
            <div className="process-step-content-career">
              <h3>Application Review</h3>
              <p>Our team reviews your application, resume, and portfolio to see if there's a match.</p>
            </div>
          </AnimatedOnScroll>
          <AnimatedOnScroll className="process-step-career" delay={0.1}>
            <div className="process-step-number-career">2</div>
            <div className="process-step-content-career">
              <h3>Initial Interview</h3>
              <p>A 30-minute call with our HR team to get to know you and discuss your background.</p>
            </div>
          </AnimatedOnScroll>
          <AnimatedOnScroll className="process-step-career" delay={0.2}>
            <div className="process-step-number-career">3</div>
            <div className="process-step-content-career">
              <h3>Technical Assessment</h3>
              <p>A take-home challenge or a live coding session to evaluate your technical skills.</p>
            </div>
          </AnimatedOnScroll>
          <AnimatedOnScroll className="process-step-career" delay={0.3}>
            <div className="process-step-number-career">4</div>
            <div className="process-step-content-career">
              <h3>Final Interview & Offer</h3>
              <p>A final chat with the team lead. If everyone's happy, we'll extend an offer!</p>
            </div>
          </AnimatedOnScroll>
        </div>
      </section>

    </motion.div>
  );
};

export default Careers;